import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/categorySlice";
import categoryApis from "src/api/category";
import { common } from "src/types";
import { constants } from "src/constants/common";

// ✅ Create Category Saga
function* CreateCategorySaga({
  payload,
}: ReturnType<typeof actions.createCategoryRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      categoryApis.createCategory,
      payload
    );
    yield put(actions.createCategorySuccess(response));
  } catch (error) {
    yield put(
      actions.createCategoryError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Get Category List Saga
function* GetCategoryListSaga({
  payload,
}: ReturnType<typeof actions.getCategoryListRequest> & {
  payload: {
    page: number;
    limit: number;
    search?: string;
    status?: "active" | "inactive";
  };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      categoryApis.getCategoryList,
      payload
    );
    yield put(actions.getCategoryListSuccess(response));
  } catch (error) {
    yield put(
      actions.getCategoryListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Edit Category Saga
function* EditCategorySaga({
  payload,
}: ReturnType<typeof actions.editCategoryRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      categoryApis.editCategory,
      payload
    );
    yield put(actions.editCategorySuccess(response));
  } catch (error) {
    yield put(
      actions.editCategoryError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Delete Category Saga
function* DeleteCategorySaga({
  payload,
}: ReturnType<typeof actions.deleteCategoryRequest> & { payload: string }) {
  try {
    const response: common.ResponseGenerator = yield call(
      categoryApis.deleteCategory,
      payload
    );
    yield put(actions.deleteCategorySuccess(response));
  } catch (error) {
    yield put(
      actions.deleteCategoryError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Delete Subcategory Saga
function* DeleteSubCategorySaga({
  payload,
}: ReturnType<typeof actions.deleteSubCategoryRequest> & {
  payload: { categoryId: string; subCategoryId: string };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      categoryApis.deleteSubCategory,
      payload
    );
    yield put(actions.deleteSubCategorySuccess(response));
  } catch (error) {
    yield put(
      actions.deleteSubCategoryError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* categorySaga() {
  yield all([
    takeEvery(actions.createCategoryRequest, CreateCategorySaga),
    takeEvery(actions.getCategoryListRequest, GetCategoryListSaga),
    takeEvery(actions.editCategoryRequest, EditCategorySaga),
    takeEvery(actions.deleteCategoryRequest, DeleteCategorySaga),
    takeEvery(actions.deleteSubCategoryRequest, DeleteSubCategorySaga),
  ]);
}
